module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tooltip":{"expense":"Amount of settled and unpaid expenses for this month.","settled":"Amount of payments you have made, including partial payments.","unpaid":"Amount of unpaid expenses, including those overdue and not yet due, for this acccounting year.","overdue":"Amount of unpaid expenses that are past their due date. Make sure to complete your payments."}}}')
  delete Component.options._Ctor
}
